import { z } from 'zod/mini'

import { nonEmptyString } from './non-empty-string'

export const itemSchema = z.strictObject({
  item_legacy_id: nonEmptyString(),
  item_id: nonEmptyString(),
  item_name: nonEmptyString(),
  affiliation: nonEmptyString(),
  discount: z.number(),
  index: z.number(),
  item_brand: nonEmptyString(),
  item_category: nonEmptyString(),
  item_variant: nonEmptyString(),
  item_warranty_duration: nonEmptyString(),
  location_id: nonEmptyString(),
  price: z.number().check(z.gt(0)),
  quantity: z.number().check(z.gt(0)),
  google_business_vertical: z.literal('retail'),
})
